import React from 'react';
import { Hash } from 'viem';
import { SupportedChainId } from '@packet/constants/AppSupportChains';
import { useTokenInfo } from '@/hooks/useTokenInfo';

interface AssetSymbolProps {
  assetId: Hash;
  chainId: SupportedChainId;
}

const AssetSymbol: React.FC<AssetSymbolProps> = ({ assetId, chainId }) => {
  const { tokenInfo, loading, error } = useTokenInfo(assetId, chainId);

  if (loading) {
    return <>...</>;
  }

  if (error || !tokenInfo) {
    return <>Unknown</>;
  }

  return <>{tokenInfo.symbol}</>;
};

export default AssetSymbol;
